import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
/** Owner disposal and unmount stop both quote work and callback reporting. */
export function useCheckoutDisposal(client, active, reporting) {
  const $ = _c(8);
  let t0;
  if ($[0] !== active.current || $[1] !== client || $[2] !== reporting.current) {
    t0 = () => {
      const stop = () => {
        active.current?.abort();
        reporting.current?.abort();
      };
      const unsubscribe = client.onDispose(stop);
      return () => {
        unsubscribe();
        stop();
      };
    };
    $[0] = active.current;
    $[1] = client;
    $[2] = reporting.current;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== active || $[5] !== client || $[6] !== reporting) {
    t1 = [client, active, reporting];
    $[4] = active;
    $[5] = client;
    $[6] = reporting;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  useEffect(t0, t1);
}